import React, { FC } from "react";

export const Preloader: FC = () => {
  return (
    <div className="p_b_preloader">
      <img
        src="https://assets-global.website-files.com/651f0451acd1cf1eb674532d/657223dc690f13a86f06e953_preloader.gif"
        loading="lazy"
        className="preloadergif"
      />
    </div>
  );
};
